import React from "react";
import { Card } from "antd";
import {Link} from "react-router-dom"
import "./styles.css";
import { REFUSED } from "dns";
const { Meta } = Card;




const Footer: React.FC = () => {


  return (
    <div className="footer">
        <div className="footerContacto">
          <h1>CONTACTO</h1>
          <div className="cardInfoContacto">
            <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1664124626/just/whatsapp_3_ri49yn.png"/>
            <p>5576635463</p>
          </div>
          <div className="cardInfoContacto">
            <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1664124626/just/email_2_pglfnj.png"/>
            <p>alexborrayo21@hotmail.com</p>
          </div>
        </div>
        <div className="footerContacto">
          <h1>NUESTRAS REDES SOCIALES</h1>
          <div className="divRedes">
          <Link to="#"><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1664066062/just/facebook_x8ghrf.png"/></Link>
          <Link to="#"><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1664066062/just/instagram_ibkoop.png"/></Link>
          </div>
        </div>
    </div>
  );
};

export default Footer;
